import { ChangeDetectionStrategy, Component, OnDestroy, effect, inject } from '@angular/core';
import { EjecutivoCementoApiService } from '../../../services/ejecutivo-cemento-api.service';
import { EjecutivosCementoStore } from '../../../stores/ejecutivos-cemento.store';
import { EjecutivosCementoUiEffectsService } from '../ui-effects/ejecutivos-cemento-ui-effects.service';

@Component({
  selector: 'app-ejecutivos-cemento-page',
  templateUrl: './ejecutivos-cemento-page.component.html',
  styleUrls: ['./ejecutivos-cemento-page.component.css'],
  providers: [EjecutivoCementoApiService, EjecutivosCementoStore, EjecutivosCementoUiEffectsService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EjecutivosCementoPageComponent implements OnDestroy {
  readonly store = inject(EjecutivosCementoStore);
  private readonly uiEffects = inject(EjecutivosCementoUiEffectsService);
  private readonly loadingEffect = effect(() => {
    this.uiEffects.syncLoading(this.store.loading());
  });

  ngOnDestroy(): void {
    this.loadingEffect.destroy();
    this.uiEffects.syncLoading(false);
  }
}
